<template>
  <div class="content">
    <card>
      <div class="row">
        <div class="col-sm-3">
          <ArtistSelect
            @memberChangeEvent="getArtistInfo"
            :is-filter="true"
            :show-members="false"
            :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          />
        </div>
        <div class="col-sm-2">
          <div class="row">
            <h4 class="card-title text-left">표시</h4>
            <div class="col-sm-12 text-left">
              <div class="row">
                <div class="col-sm-12 text-left">
                  <el-select @change="getBanners" class="select-primary" size="large" placeholder="선택" v-model="state.state">
                    <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="row">
            <h4 class="card-title text-left">배너위치</h4>
            <div class="col-sm-12 text-left">
              <div class="row">
                <div class="col-sm-12 text-left">
                  <el-select @change="getBanners" class="select-primary" size="large" placeholder="선택" v-model="namespace">
                    <el-option v-for="option in namespaces" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="state.state === 1 && unitId" class="col-md-3">
          <div class="row">
            <div class="col-md-12">
              <base-button @click="setBannerOrder" type="default">노출순서변경</base-button>

              <el-popover trigger="hover" placement="top">
                <div>
                  <div class="popover-body">드래그앤드랍으로 노출순서를 변경할 수 있습니다</div>
                </div>
                <base-button slot="reference"> ? </base-button>
              </el-popover>
            </div>
          </div>
        </div>
        <base-button @click="goBannerForm()" type="default">배너 등록</base-button>
      </div>
    </card>
    <draggable class="row" v-model="banners" group="people" @start="drag = true" @end="drag = false">
      <div class="col-sm-3" v-for="(item, index) in banners">
        <card class="card">
          <div class="row">
            <img v-if="item.imageFileUrl" slot="image" class="card-img-top cover-img" v-bind:src="item.imageFileUrl" :alt="item.title" />
            <img v-else src="@/assets/img/blip-logo.png" />
          </div>
          <p class="card-text">{{ item.unitName }}</p>
          <p class="card-text">{{ item.title }}</p>
          <p class="card-text">{{ item.description }}</p>
          <p class="card-text">{{ item.namespace }} {{ item.position }}</p>
          <p class="card-text">{{ item.startTime }}</p>
          <p>{{ item.endTime }}</p>
          <base-button @click="goBannerForm(item.bannerId)" type="default">상세</base-button>
        </card>
      </div>
    </draggable>
  </div>
</template>
<script>
import { BaseButton, Card } from "@/components/index";
import draggable from "vuedraggable";
import { formatDateTime } from "@/util/DateUtils";
import ArtistSelect from "@/pages/Components/ArtistSelect";
import { BlipNamespace } from "@/common/BlipNamespace";

export default {
  components: {
    ArtistSelect,
    Card,
    BaseButton,
    draggable,
  },
  async created() {
    await this.getBanners();
  },
  data() {
    return {
      namespace: null,
      namespaces: [
        { label: "전체", value: null },
        { label: "메인", value: BlipNamespace.TODAY },
        { label: "알림", value: BlipNamespace.NOTIFICATION },
        { label: "타임라인", value: BlipNamespace.TIMELINE },
      ],
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "표시", value: 1 },
          { label: "숨김", value: 0 },
        ],
      },
      banners: [],
    };
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;

      await this.getBanners();
    },
    async getBanners() {
      return this.$axios.get(`/eventBanner`, { params: { unitId: this.unitId, state: this.state.state } }).then((res) => {
        this.banners = res.data.data
          .map((banner) => {
            if (this.namespace) {
              if (this.namespace !== banner.namespace) {
                return null;
              }
            }
            banner.imageFileUrl = window.Endpoints.imageServerUrl + banner.imageFileId;
            banner.startTime = formatDateTime(banner.startTime);
            banner.endTime = formatDateTime(banner.endTime);
            if (banner.namespace === BlipNamespace.NOTIFICATION) {
              banner.namespace = "알림";
            } else if (banner.namespace === BlipNamespace.TODAY) {
              banner.namespace = "메인";
            } else if (banner.namespace === BlipNamespace.TIMELINE) {
              banner.namespace = "타임라인";
            }
            if (banner.position === 1) {
              banner.position = "상단";
            } else if (banner.position === 2) {
              banner.position = "중단";
            } else if (banner.position === 3) {
              banner.position = "하단";
            }
            return banner;
          })
          .filter((banner) => banner !== null);
      });
    },
    async setBannerOrder() {
      const banners = [];
      this.banners.forEach((banner, order) => {
        banners.push({ bannerId: banner.bannerId, order, unitId: this.unitId });
      });
      return this.$axios.put("/eventBanner/order", { banners }).then((res) => {
        Toast.success("배너의 노출순서가 변경되었습니다");
        this.getBanners();
      });
    },
    goBannerForm(bannerId) {
      if (bannerId) {
        this.$router.push(`/banner/eventBannerForm?bannerId=${bannerId}`);
      } else {
        this.$router.push(`/banner/eventBannerForm`);
      }
    },
  },
};
</script>
<style></style>
